import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  listContainer: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.padding("6px", "0px", "0px", "0px"),
    ...shorthands.gap("6px"),
  },
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    ...shorthands.padding("0px", "18px", "0px", "18px"),
  },
  header: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-start",
    ...shorthands.padding("19px", "0px", "9px", "0px"),
    "@media (min-width: 500px)": {
      ...shorthands.padding("19px", "18px", "9px", "18px"),
    },
  },
  headerText: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase500,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase500,
  },
  smallHeaderText: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase300,
  },
  list: {
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    ...shorthands.padding("6px", "18px", "0px", "18px"),
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
      maxWidth: "100%",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("auto"),
      maxWidth: "100%",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
      maxWidth: "100%",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("auto"),
      maxWidth: "100%",
      ...shorthands.padding("6px", "0px", "0px", "0px"),
    },
  },
  bottomSpacer: {
    marginBottom: "30px",
  },
});
